import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterHostFamilyCost } from '../../../lib/types/models/center/center-host-family-cost'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterHostFamilyCosts(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getCenterHostFamilyCosts.url, { id }), query)
    )
    .get<PaginationResponse<CenterHostFamilyCost>>()
}
